import React from 'react'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import MarketingContent, { MarketingQuestionAndAnswer, PrivacyPolicyLink } from '@sputnik/components/MarketingContent'

const ConnectBankAccountFormMarketingContent = () => {
  const { formatMessage } = useIntl()

  return (
    <MarketingContent
      footer={<PrivacyPolicyLink />}
      image={{
        alt: formatMessage({
          defaultMessage: 'the hands of a person using the Bill app, viewing their payables and receivables',
          id: 'sputnik.ConnectBankAccountFormMarketingContent__PGzoLJ',
        }),
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-connect-bank-account-marketing-content.png',
      }}
      pillText={
        <FormattedMessage
          defaultMessage='Pro tip'
          id='sputnik.ConnectBankAccountFormMarketingContent__0oV4Vc'
        />
      }
    >
      <MarketingQuestionAndAnswer
        answer={
          <FormattedMessage
            defaultMessage='Connect your bank to access your best offer. This helps us verify your account, show your full credit potential, and make repayments seamless. You can skip for now, but linking a bank lets you get more credit and smooths future payments.'
            id='sputnik.ConnectBankAccountFormMarketingContent__/ExjM1'
          />
        }
        question={
          <FormattedMessage
            defaultMessage='Why should I connect my bank account?'
            id='sputnik.ConnectBankAccountFormMarketingContent__sDFvpG'
          />
        }
      />
    </MarketingContent>
  )
}

export default ConnectBankAccountFormMarketingContent
